import Svg, { Path } from '@rd-core-svg/svg'
import type { LogoSvgProps } from '../svg.types'

export const RDSaudeYellow = (props: LogoSvgProps) => {
  const { height, width } = props

  return (
    <Svg {...props} viewBox="0 0 172 32" fill="none">
      <Path
        d="M31.4077 16.7808L23.319 17.2381C19.6391 17.4307 17.5258 19.5608 17.3436 23.2072L16.8821 31.2222C16.8457 32.0164 17.6108 32.2812 18.2181 31.6434L31.8328 18.1046C32.4522 17.4668 32.2214 16.7447 31.4077 16.7808Z"
        fill="#4CA15D"
      />
      <Path
        d="M18.2181 0.365659C17.5986 -0.2842 16.8335 -0.0194427 16.8821 0.786865L17.3436 8.8018C17.5379 12.4482 19.639 14.5783 23.319 14.7709L31.4077 15.2282C32.2093 15.2643 32.44 14.5422 31.8328 13.9044L18.2181 0.365659Z"
        fill="#4CA15D"
      />
      <Path
        d="M14.8419 23.1955C14.6476 19.549 12.5465 17.4189 8.86652 17.2264L0.777856 16.7691C-0.0237235 16.733 -0.254479 17.4911 0.352778 18.0929L13.9675 31.6196C14.5869 32.2694 15.352 32.0047 15.3035 31.1984L14.8419 23.1955Z"
        fill="#4CA15D"
      />
      <Path
        d="M13.9673 0.365864L0.352633 13.8926C-0.26677 14.5063 -0.036014 15.2645 0.777711 15.2164L8.86638 14.7591C12.5464 14.5665 14.6596 12.4364 14.8418 8.78997L15.3033 0.775035C15.3519 -0.0192385 14.5746 -0.283996 13.9673 0.365864Z"
        fill="#4CA15D"
      />
      <Path
        d="M135.383 5.19165H131.751L127.804 9.48794H130.974L135.383 5.19165Z"
        fill="#0A2F2A"
      />
      <Path
        d="M151.742 14.3499C150.503 12.3521 148.499 11.3653 146.252 11.3653C142.269 11.3653 138.868 14.6989 138.868 19.2599C138.868 24.1218 142.074 27.1184 146.252 27.1184C148.693 27.1184 150.503 25.927 151.742 24.2783V26.8055H154.608V5.19165H151.742V14.3499ZM151.742 21.2456C151.013 23.1952 149.228 24.6152 146.835 24.6152C144.054 24.6152 141.807 22.5814 141.807 19.2479C141.807 15.7218 143.969 13.8444 146.835 13.8444C149.228 13.8444 151.05 15.4209 151.742 17.3705V21.2456Z"
        fill="#0A2F2A"
      />
      <Path
        d="M172 18.5621C172 14.4222 169.097 11.3655 164.579 11.3655C160.329 11.3655 156.964 14.7351 156.964 19.2601C156.964 24.0859 160.134 27.1186 164.774 27.1186C167.786 27.1186 170.3 25.8549 171.466 23.8211L169.304 22.365C168.454 23.7008 166.79 24.6274 164.859 24.6274C162.296 24.6274 160.146 23.0028 159.867 19.9581H171.891C171.951 19.4887 172 19.0194 172 18.5621ZM160.001 17.5632C160.523 15.3729 162.102 13.8446 164.567 13.8446C167.008 13.8446 168.854 15.3007 169.049 17.5632H160.001Z"
        fill="#0A2F2A"
      />
      <Path
        d="M133.767 20.5958C133.767 23.5082 132.176 24.6153 129.869 24.6153C127.67 24.6153 125.97 23.3878 125.97 20.5958V11.6663H123.104V20.3672C123.104 25.0004 125.776 27.1064 129.869 27.1064C133.816 27.1064 136.633 24.844 136.633 20.3672V11.6663H133.767V20.5958Z"
        fill="#0A2F2A"
      />
      <Path
        d="M97.4287 17.8761C95.2304 17.2985 94.028 16.9615 94.028 15.6979C94.028 14.5907 95.0725 13.8566 96.8093 13.8566C98.5096 13.8566 100.137 14.4704 101.254 15.4692L102.566 13.2428C101.254 12.0153 99.044 11.3655 96.955 11.3655C93.5179 11.3655 91.1618 13.2067 91.1618 15.9626C91.1618 18.9833 93.943 19.8257 96.3842 20.4033C98.2788 20.8607 99.9791 21.4022 99.9791 22.7019C99.9791 23.8933 98.8982 24.6154 96.9307 24.6154C95.0725 24.6154 93.2629 23.8452 91.9391 22.738L90.6152 24.9644C92.1212 26.2641 94.6353 27.1065 97.0764 27.1065C100.55 27.1065 102.87 25.2292 102.87 22.5094C102.87 19.6331 100.477 18.6824 97.4287 17.8761Z"
        fill="#0A2F2A"
      />
      <Path
        d="M117.298 14.35C116.059 12.3523 114.055 11.3655 111.809 11.3655C107.825 11.3655 104.424 14.699 104.424 19.2601C104.424 24.122 107.631 27.1186 111.809 27.1186C114.25 27.1186 116.059 25.9272 117.298 24.2784V26.8057H120.164V11.6663H117.298V14.35ZM117.298 21.2458C116.569 23.1953 114.784 24.6154 112.392 24.6154C109.61 24.6154 107.363 22.5816 107.363 19.248C107.363 15.7219 109.525 13.8446 112.392 13.8446C114.784 13.8446 116.606 15.4211 117.298 17.3707V21.2458Z"
        fill="#0A2F2A"
      />
      <Path
        d="M55.0906 18.7665V18.0444C58.2605 17.6714 60.3252 15.2765 60.3252 12.2077C60.3252 7.28564 56.3902 5.19165 51.4106 5.19165H37.4194V26.7935H42.654V20.1625H49.5403C53.7061 20.1625 54.5077 23.6525 55.3943 26.7935H61.2482C60.143 22.6657 59.22 19.3321 55.0906 18.7665ZM51.0706 15.806H42.654V9.54812H51.0706C53.2081 9.54812 54.9692 10.4627 54.9692 12.653C54.9813 14.6748 53.366 15.806 51.0706 15.806Z"
        fill="#0A2F2A"
      />
      <Path
        d="M74.5109 5.19165H63.9932V26.7935H74.5109C81.7372 26.7935 87.4819 23.1952 87.4819 15.9986C87.4819 9.3315 82.0409 5.19165 74.5109 5.19165ZM74.5109 22.437H69.2277V9.54812H74.5109C78.9803 9.54812 82.1259 12.0513 82.1259 15.9865C82.1259 20.355 78.6767 22.437 74.5109 22.437Z"
        fill="#0A2F2A"
      />
    </Svg>
  )
}
